/**
 * @generated SignedSource<<6f0b2c8149e876ba26f1a2db2019d5de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedItemDetailsList_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_refactor_user" | "PdpSharedDetailReference_user">;
  readonly " $fragmentType": "PdpRespSharedItemDetailsList_user";
};
export type PdpRespSharedItemDetailsList_user$key = {
  readonly " $data"?: PdpRespSharedItemDetailsList_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsList_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedItemDetailsList_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_refactor_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "db259bd7dbd67e8e6de1e17b23f2aa9a";

export default node;
